/**
 * Angular library starter
 * Build an Angular library compatible with AoT compilation & Tree shaking like an official package
 * Copyright Roberto Simonetti
 * MIT license
 * https://github.com/robisim74/angular-library-starter
 */

/**
 * Entry point for all public APIs of the package.
 */
export * from './src/agm-direction';
export * from './src/modules/agm-direction.module';
export * from './src/directive/agm-direction.directive';

// This file only reexports content of the `src` folder. Keep it that way.
